import {
  Button as ButtonComponent,
  ButtonProps as MatButtonProps,
} from "@material-ui/core";

export function Button({
  variant = "contained",
  color = "primary",
  type = "button",
  ...rest
}: MatButtonProps) {
  return (
    <ButtonComponent {...rest} type={type} variant={variant} color={color} />
  );
}
